import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const loadLocaleResources = () => {
  const localeContext = require.context('./locales', true, /translation\.json$/);
  const loadedResources = {};

  localeContext.keys().forEach((key) => {
    const locale = key.split('/')[1];
    const localeTranslation = localeContext(key);
    loadedResources[locale] = { translation: localeTranslation };
  });

  return loadedResources;
};

const getUserLocale = () => {
  const locale = localStorage.getItem('locale');
  return locale || 'hu'; 
};

i18n
  .use(initReactI18next)
  .init({
    resources: loadLocaleResources(),
    lng: getUserLocale(), // Kezdő nyelv a localStorage alapján
    fallbackLng: 'hu', // Ha nincs localStorage adat, akkor alapértelmezett a magyar
    interpolation: {
      escapeValue: false // React már kezeli az escape-elést
    }
  });

export default i18n;
